/**
 * KnobGroupCard — one grouped card (Cadences / Retention / Tuning) of the
 * knob registry, rendered as a responsive grid of `KnobField`s (WSRPDM-0014).
 */
import { Grid, Paper, Typography } from '@mui/material';
import type { ScheduleKnobDef, ScheduleKnobKey } from '@/domain/scheduleKnobs';
import { KnobField } from './KnobField';

interface KnobGroupCardProps {
  title?: string;
  knobs: readonly ScheduleKnobDef[];
  form: Record<ScheduleKnobKey, string | boolean>;
  fieldErrors: Partial<Record<ScheduleKnobKey, string>>;
  invariantFields: readonly ScheduleKnobKey[];
  onChange: (key: ScheduleKnobKey, value: string | boolean) => void;
}

export function KnobGroupCard({
  title,
  knobs,
  form,
  fieldErrors,
  invariantFields,
  onChange,
}: KnobGroupCardProps) {
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
      {title ? (
        <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
          {title}
        </Typography>
      ) : null}
      <Grid container spacing={2}>
        {knobs.map((def) => (
          <Grid key={def.key} size={{ xs: 12, sm: 6, md: 4 }}>
            <KnobField
              def={def}
              value={form[def.key]}
              error={fieldErrors[def.key]}
              invariant={invariantFields.includes(def.key)}
              onChange={(value) => onChange(def.key, value)}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
